import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { MissionPlace } from 'src/app/shared/models/mission/mission-place';
import { NominatimResponse } from 'src/app/shared/models/api-response/nominatim-response';
import { Specialite } from 'src/app/shared/models/specialite';
import { LogService } from 'src/app/core/services/log/log.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { FormGroup } from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { Observable, of, Subscriber } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

@Component({
	selector: 'app-mission-place-form',
	templateUrl: './mission-place-form.component.html',
	styleUrls: ['./mission-place-form.component.scss']
})
export class MissionPlaceFormComponent implements OnInit {
	@Input() missionPlace: MissionPlace;
	@Input() isAddForm: boolean;
	@Input() isAddressSelected: { value: boolean };
	@Input() isAddressDefault: { value: boolean };
	@Input() form: FormGroup;
	@Output() sendForm: EventEmitter<any> = new EventEmitter();
	@Output() hideModal: EventEmitter<any> = new EventEmitter();
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	@Input() isValidateButtonClicked: { value: boolean };

	MAX_NAME_CHAR = 50;
	NAME_PATTERN = new RegExp("^[0-9a-zA-z'éèàç.-_]+( [0-9a-zA-z'éèàç.-_]+)*$");

	selectedaddress?: Address;
	typeaheadLoading?: boolean;
	addressList: Observable<NominatimResponse[]>;
	searchResults: NominatimResponse[];

	listSpecialite: Specialite[];
	listSelectedSpecialite: Specialite[] = [];

	constructor(
		private router: Router,
		private cacheService: CacheService,
		private logger: LogService,
		private facade: FacadeService,
		private toastService: ToastService
	) {
		this.addressList = new Observable((observer: Subscriber<string>) => {
			// Runs on every search
			observer.next(this.form.value.address);
		}).pipe(
			mergeMap((token: string) =>
				this.getNominatimDisplaynameAsObservable(token)
			)
		);
	}

	ngOnInit(): void {
		if (this.missionPlace) {
			this.facade.specialiteService
				.getAllSpecialites()
				.subscribe((specialties) => (this.listSpecialite = specialties));
			this.listSelectedSpecialite = [...this.missionPlace?.specialties];
		}
	}

	onSubmit(): void {
		if (
			this.form.valid &&
			(this.isAddressDefault.value || this.isAddressSelected.value)
		) {
			this.isValidateButtonClicked.value = true;
			this.missionPlace.name = this.form.get('name').value;
			this.missionPlace.nameDisplay = this.missionPlace.name;
			if (this.isAddressSelected.value && this.selectedaddress) {
				this.missionPlace.address = this.selectedaddress;
			} else {
				if (this.isAddForm) {
					const adr = new Address();
					adr.label = this.form.get('address').value;
					this.missionPlace.address = adr;
				}
			}
			if (this.listSelectedSpecialite.length === 0) {
				//FIXME: A gerer par le back
				this.missionPlace.specialties = [];
			} else {
				this.missionPlace.specialties = this.listSelectedSpecialite;
			}
			this.missionPlace.notes = this.form.get('notes').value;

			this.sendForm.emit();
		} else {
			this.isValidateButtonClicked.value = false;
		}
	}

	onAddressSelect(event: TypeaheadMatch) {
		this.isAddressDefault.value = false;
		this.isAddressSelected.value = true;
		this.selectedaddress = new Address();
		this.selectedaddress.label = event.item.displayName;
		this.selectedaddress.latitude = event.item.latitude;
		this.selectedaddress.longitude = event.item.longitude;
		this.form.controls['address'].updateValueAndValidity();
	}

	getNominatimDisplaynameAsObservable(
		token: string
	): Observable<NominatimResponse[]> {
		this.isAddressSelected.value = false;
		this.facade.nominatimService.addressLookup(token).subscribe({
			next: (result: any) => {
				this.searchResults = result.features.map(
					(feature) =>
						new NominatimResponse(
							feature.geometry.coordinates[0],
							feature.geometry.coordinates[1],
							feature.properties.label
						)
				);
			},
			error: (err) => {
				this.logger.error(err);
			}
		});
		return of(this.searchResults);
	}

	selectedAddressKeyUp(e: any) {
		this.isAddressDefault.value = false;
		if (this.selectedaddress) {
			if (this.selectedaddress?.label === e.value) {
				this.isAddressSelected.value = true;
			}
		}
		this.form.controls['address'].updateValueAndValidity();
	}

	changeTypeaheadLoading(e: boolean): void {
		this.typeaheadLoading = e;
	}

	isSpecialiteCheck(spec: Specialite): boolean {
		return this.listSelectedSpecialite?.some(
			(specItfc) => specItfc.id === spec.id
		);
	}

	/**
	 * Ajoute ou supprime la spécialité à la liste des spécialités sélectionnées
	 * @param e Element html
	 * @param spe String representant la specialite choisie
	 */
	updateSelectedSpecialite(e: any, spe: Specialite) {
		if (e.target.checked) {
			if (!this.listSelectedSpecialite.some((e) => e.id === spe.id)) {
				this.listSelectedSpecialite.push(spe);
			}
		} else {
			if (this.listSelectedSpecialite.some((e) => e.id === spe.id)) {
				this.listSelectedSpecialite = this.listSelectedSpecialite.filter(
					(e) => e.id !== spe.id
				);
			}
		}
	}

	get name() {
		return this.form.get('name');
	}
	get address() {
		return this.form.get('address');
	}

	get notes() {
		return this.form.get('notes');
	}
}
